//FireBase
var config = {
  	apiKey: "AIzaSyB4mf1qd8sJtU-v4OFK1i4pAi0GCudvrQ8",
    authDomain: "getmvp-43441.firebaseapp.com",
    databaseURL: "https://getmvp-43441.firebaseio.com",
    projectId: "getmvp-43441",
    storageBucket: "getmvp-43441.appspot.com",
    messagingSenderId: "620716447948",
    appId: "1:620716447948:web:fdbd600deccb9607"
};
  
exports.config = config;



// WEBPACK FOOTER //
// ./src/config/firebase_config.js